export default __webpack_public_path__ + "static/george-b8f121908d4663382ae512687f62be43.jpg";